/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import { getTranslationForIso } from '../../../utils/components';

import { FormattedDate } from 'react-intl';
import { Table, Row, ButtonGroup, Button } from "reactstrap";

import TableActionCell from "../TableActionCell";

import styles from "./index.module.scss";
import getConfig from '../../../getConfig';
import { defaultHeightConfig } from '../../../config/_homePage';

import { getFileFormat, isVideo, isImage } from '../../../utils/files';

const propTypes = {
    slides: PropTypes.arrayOf(PropTypes.object),
    translations: PropTypes.shape({
        columnNames: PropTypes.shape({
            photo: PropTypes.string,
            alternativeText: PropTypes.string,
            actions: PropTypes.string
        }),
        tooltipTranslations: PropTypes.shape({
            remove: PropTypes.string,
            edit: PropTypes.string,
        }).isRequired,
        emptyTable: PropTypes.string,
        deleteModalTranslations: PropTypes.shape({
            header: PropTypes.string,
            body: PropTypes.string,
            confirm: PropTypes.string,
            cancel: PropTypes.string
        }).isRequired
    }),
    removeAction: PropTypes.func.isRequired,
    editAction: PropTypes.func.isRequired,
    editImageAction: PropTypes.func.isRequired,
    changeSlideOrder: PropTypes.func
};

/** @type {(object: { ImageSource?: string, imageSource?: string }) => string | undefined} */
function getImageSource(object)
{
    return object.ImageSource ?? object.imageSource;
}

const AnimatedBannerImagesTable = ({
    section,
    slides,
    removeAction,
    translations,
    editAction,
    editImageAction,
    changeSlideOrder,
    updateBannerImage,
    currentLanguage
}) => {

    const apiUrl = getConfig().BACKEND_EXTERNAL_URL;

    const removeActionHandler = (bannerId, id) => () => {
        removeAction(bannerId, id);
    };
    const editActionHandler = id => () => {
        editAction(id);
    };

    const changeOrderHandler = (id, delta, slide) => e => {
        e.stopPropagation();

        changeSlideOrder(id, delta, slide);
    };

    const handleActiveSwitch = (slide, activeKey, isActive) => () => {
        const objectToSend = {
            ...slide,
            [activeKey]: !isActive,
        };

        updateBannerImage(slide.animatedBannerImageId, objectToSend);
    };

    const handleImageEdit = (slide, device) =>
    {
        const deviceLower = String(device).toLowerCase();

        switch (deviceLower)
        {
            case 'desktop':
            {
                const ss = slide.desktop.SlideSettings;
                const editorSettings =
                {
                    image: { source: getImageSource(slide.desktop) },
                    elements: ss?.settings ?? [],
                    aspectRatio: 0.2,
                };
                editImageAction
                (
                    slide, device, editorSettings,
                    '100%',
                    section.desktopSettings.height || defaultHeightConfig.desktop
                );
                break;
            }
            case 'tablet':
            {
                const ss = slide.tablet.SlideSettings;
                const editorSettings =
                {
                    image: { source: getImageSource(slide.tablet) },
                    elements: ss?.settings ?? [],
                    aspectRatio: 0.2,
                };
                
                editImageAction
                (
                    slide, device, editorSettings,
                    '768px',
                    section.tabletSettings.height || defaultHeightConfig.tablet
                );
                break;
            }
            case 'mobile':
            {
                const ss = slide.mobile.SlideSettings;
                const editorSettings =
                {
                    image: { source: getImageSource(slide.mobile) },
                    elements: ss?.settings ?? [],
                    aspectRatio: 0.2,
                };
                editImageAction
                (
                    slide, device, editorSettings,
                    '600px',
                    section.mobileSettings.height || defaultHeightConfig.mobile
                );
                break;
            }
        }
    }

    return slides && slides.length > 0 ? (
        <Table responsive hover size="sm">
            <thead>
                <tr>
                    <th>
                        {translations.columnNames.order}
                    </th>
                    <th>
                        {translations.columnNames.desktopImage}
                    </th>
                    <th>
                        {translations.columnNames.tabletImage}
                    </th>
                    <th>
                        {translations.columnNames.mobileImage}
                    </th>
                    <th>
                        {translations.columnNames.link}
                    </th>
                    <th>
                        {translations.columnNames.dates}
                    </th>
                    <th>
                        {translations.columnNames.activeInLanguage}
                    </th>
                    <th className={styles.actionHeader}>
                        {translations.columnNames.actions}
                    </th>
                </tr>
            </thead>
            <tbody>
                {
                    slides.sort((slideA, slideB) => slideA.lp - slideB.lp).map((slide, index) => {
                        return (
                            <tr className={styles.row} onClick={editActionHandler(slide)} key={`photo-${slide.animatedBannerImageId}`}>
                                <td className={clsx(styles.cell)}>
                                    <ButtonGroup vertical>
                                        <Button
                                            color="primary"
                                            size="sm"
                                            disabled={index === 0}
                                            onClick={changeOrderHandler(slide.animatedBannerImageId, -1, slide)}
                                        >
                                            <i className="cil-arrow-thick-top"></i>
                                        </Button>
                                        <Button
                                            color="primary"
                                            size="sm"
                                            disabled={index === slides.length - 1}
                                            onClick={changeOrderHandler(slide.animatedBannerImageId, 1, slide)}
                                        >
                                            <i className="cil-arrow-thick-bottom"></i>
                                        </Button>
                                    </ButtonGroup>
                                </td>
                                <td className={clsx(styles.imageContainer, styles.cellBottom)}>
                                    {isVideo(getFileFormat(getImageSource(slide.desktop))) &&
                                        <video
                                            autoPlay={true}
                                            muted={true}
                                            loop={'loop'}
                                            controls={false}
                                            height={'100%'}
                                            width={'100%'}
                                            style={{objectFit: 'cover'}}
                                        >
                                            <source src={`${apiUrl}${getImageSource(slide.desktop)}`} type={'video/'+getFileFormat(getImageSource(slide.desktop))} />
                                        </video>
                                    }
                                    {isImage(getFileFormat(getImageSource(slide.desktop))) &&
                                        <img className={styles.image} src={`${apiUrl}${getImageSource(slide.desktop)}`} alt={getTranslationForIso(slide.desktop.imageAlternativeText, currentLanguage)}/>
                                    }

                                    {getImageSource(slide.desktop) &&
                                        <div style={{display: 'flex', justifyContent: 'left', alignItems: 'center', alignContent: 'center', margin: '5px'}} onClick={(e) => {e.stopPropagation()}}>
                                            <label className="switch switch-pill switch-success m-1">
                                                <input
                                                    type="checkbox"
                                                    className="switch-input"
                                                    checked={slide.activeDesktop}
                                                    onChange={handleActiveSwitch(slide, 'activeDesktop', slide.activeDesktop)}
                                                />
                                                <span
                                                    className={clsx("switch-slider", !slide.activeDesktop &&  "bg-danger border-danger")}
                                                ></span>
                                            </label>

                                                <button className="btn btn-primary m-1" style={{display:'flex', alignItems: 'center', alignContent: 'space-between'}}
                                                    onClick={()=>{handleImageEdit(slide, 'Desktop');}}><i className="fa fa-edit fa-sm my-1 mx-1"></i> Zawartość</button>
                                        </div>
                                    }
                                    {!getImageSource(slide.desktop) && <span><i>{translations.emptyImage}</i></span>}
                                </td>

                                <td className={clsx(styles.imageContainer, styles.cellBottom)}>
                                    {isVideo(getFileFormat(getImageSource(slide.tablet))) &&
                                        <video
                                            autoPlay={true}
                                            muted={true}
                                            loop={'loop'}
                                            controls={false}
                                            height={'100%'}
                                            width={'100%'}
                                            style={{objectFit: 'cover'}}
                                        >
                                            <source src={`${apiUrl}${slide.tablet.imageSource}`} type={'video/'+getFileFormat(slide.tablet.imageSource)} />
                                        </video>
                                    }
                                    {isImage(getFileFormat(getImageSource(slide.tablet))) &&
                                        <img className={styles.image} src={`${apiUrl}${getImageSource(slide.tablet)}`} alt={getTranslationForIso(slide.tablet.imageAlternativeText, currentLanguage)}/>
                                    }

                                    {getImageSource(slide.tablet) &&
                                        <div style={{display: 'flex', justifyContent: 'left', alignItems: 'center', alignContent: 'center', margin: '5px'}} onClick={(e) => {e.stopPropagation()}}>
                                            <label className="switch switch-pill switch-success m-1">
                                                <input
                                                    type="checkbox"
                                                    className="switch-input"
                                                    checked={slide.activeTablet}
                                                    onChange={handleActiveSwitch(slide, 'activeTablet', slide.activeTablet)}
                                                />
                                                <span
                                                    className={clsx("switch-slider", !slide.activeTablet &&  "bg-danger border-danger")}
                                                ></span>
                                            </label>
                                            <button className="btn btn-primary m-1" style={{display:'flex', alignItems: 'center', alignContent: 'space-between'}}
                                                onClick={()=>{handleImageEdit(slide, 'Tablet');}}><i className="fa fa-edit fa-sm my-1 mx-1"></i> Zawartość</button>
                                        </div>
                                    }
                                    {!getImageSource(slide.tablet) && <span><i>{translations.emptyImage}</i></span>}
                                </td>
                                <td className={clsx(styles.imageContainer, styles.cellBottom)}>
                                    {isVideo(getFileFormat(getImageSource(slide.mobile))) &&
                                        <video
                                            autoPlay={true}
                                            muted={true}
                                            loop={'loop'}
                                            controls={false}
                                            height={'100%'}
                                            width={'100%'}
                                            style={{objectFit: 'cover'}}
                                        >
                                            <source src={`${apiUrl}${getImageSource(slide.mobile)}`} type={'video/'+getFileFormat(getImageSource(slide.mobile))} />
                                        </video>
                                    }
                                    {isImage(getFileFormat(getImageSource(slide.mobile))) &&
                                        <img className={styles.image} src={`${apiUrl}${getImageSource(slide.mobile)}`} alt={getTranslationForIso(slide.mobile.imageAlternativeText, currentLanguage)}/>
                                    }

                                    {getImageSource(slide.mobile) &&
                                        <div style={{display: 'flex', justifyContent: 'left', alignItems: 'center', alignContent: 'center', margin: '5px'}} onClick={(e) => {e.stopPropagation()}}>
                                            <label className="switch switch-pill switch-success m-1">
                                                <input
                                                    type="checkbox"
                                                    className="switch-input"
                                                    checked={slide.activeMobile}
                                                    onChange={handleActiveSwitch(slide, 'activeMobile', slide.activeMobile)}
                                                />
                                                <span
                                                    className={clsx("switch-slider", !slide.activeMobile &&  "bg-danger border-danger")}
                                                ></span>
                                            </label>
                                            <button className="btn btn-primary m-1" style={{display:'flex', alignItems: 'center', alignContent: 'space-between'}}
                                                onClick={()=>{handleImageEdit(slide, 'Mobile');}}><i className="fa fa-edit fa-sm my-1 mx-1"></i> Zawartość</button>
                                        </div>
                                    }
                                    {!getImageSource(slide.mobile) && <span><i>{translations.emptyImage}</i></span>}
                                </td>
                                <td className={clsx(styles.cell)}>
                                    <span>{slide.link}</span>
                                </td>
                                <td className={clsx(styles.cell)}>
                                    {
                                        slide.dateFrom
                                            ? <FormattedDate value={slide.dateFrom} day='2-digit' month='2-digit' year='numeric' />
                                            : null
                                    }
                                    <span>-</span>
                                    {
                                        slide.dateTo
                                            ? <FormattedDate value={slide.dateTo} day='2-digit' month='2-digit' year='numeric' />
                                            : null
                                    }
                                </td>
                                <td className={clsx(styles.cell)}>
                                    {
                                        slide.activeInLanguage
                                    }
                                </td>
                                <td className={clsx(styles.cell)} onClick={e => e.stopPropagation()}>
                                    <TableActionCell
                                        itemId={slide.animatedBannerImageId}
                                        actions={{
                                            edit: {
                                                tooltipTranslation: translations.tooltipTranslations.edit,
                                                action: editActionHandler(slide),
                                            },
                                            delete: {
                                                action: removeActionHandler(slide.animatedBannerId, slide.animatedBannerImageId),
                                                modalTranslations: translations.deleteModalTranslations,
                                                tooltipTranslation: translations.tooltipTranslations.remove
                                            },
                                        }}
                                    />
                                </td>
                            </tr>
                        );
                    })
                }
            </tbody>
        </Table>
    ) : (
        <Row className="d-flex justify-content-center mt-4 mb-4">
            {translations.emptyTable}
        </Row>
    );
};

AnimatedBannerImagesTable.propTypes = propTypes;

export default AnimatedBannerImagesTable;
